import { render, staticRenderFns } from "./speedTest.vue?vue&type=template&id=2a02c270&"
import script from "./speedTest.vue?vue&type=script&lang=js&"
export * from "./speedTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports